import React, { Fragment, useState } from 'react'
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { H5, LI, UL } from '../../AbstractElements'
import SidebarSubMenu from './SidebarSubMenu'
import { RootState } from '../../ReduxToolkit/Store';
import { Pinned } from '../../Utils/Constants';
import { SidebarMenuItem } from '../../Types/Layout.type';
import { menuList } from '../../Data/Layout/SidebarMenuList';

export default function SidebarNav() {
    const { t } = useTranslation();
    const [activeMenu, setActiveMenu] = useState<string[]>([]);
    const { pinedMenu } = useSelector((state: RootState) => state.layout);

    // Retrieve usertype from localStorage
    const usertype = localStorage.getItem("usertype");
    console.log("Usertype:", usertype);  // Debugging
    
    const filteredMenuList = menuList
    .map((menu) => ({
        ...menu,
        items: menu.items
            ? menu.items.filter((item) => {
                if (usertype === "1") return item.id === 13 || item.id === 16 ; // Token menu for usertype 1
                if (usertype === "2") return item.id === 12 || item.id===17; // Weekly Booking for usertype 2
                if (usertype === "3") return  item.id === 23 ||  item.id === 24 || item.id === 15 || item.id===14 || item.id===17 || item.id===18 || item.id === 19 || item.id === 21 ;  // Medicine details for usertype 3
                return false; // not allow items if usertype is missing
            })
            : [],
    }))
    .filter((menu) => menu.items.length > 0);

    
    console.log("Filtered Menu List:", filteredMenuList);  // Debugging
    

    return (
        <UL className="sidebar-menu simple-list" id="simple-bar">
            <div className="simplebar-wrapper">
                <div className="simplebar-mask">
                    <div className="simplebar-offset">
                        <div className="simplebar-content-wrapper">
                            <div className="simplebar-content">
                                <LI className={`pin-title sidebar-main-title ${pinedMenu.length > 0 ? "show" : ""}`}>
                                    <div>
                                        <H5 className="sidebar-title f-w-700">{Pinned}</H5>
                                    </div>
                                </LI>
                                {filteredMenuList.map((mainMenu, index) => (
                                    <Fragment key={index}>
                                        <LI className="sidebar-main-title">
                                            <div>
                                                <H5 className={`${mainMenu.lanClass ? mainMenu.lanClass : ''} f-w-700 sidebar-title`}>
                                                    {mainMenu.title}
                                                </H5>
                                            </div>
                                        </LI>
                                        <SidebarSubMenu menu={mainMenu.items} activeMenu={activeMenu} setActiveMenu={setActiveMenu} level={0} />
                                    </Fragment>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </UL>
    );
}
